module.exports = __webpack_public_path__ + "img/parts.667779c9.svg";